export default __webpack_public_path__ + "static/media/Social-Network-API.aa93f20c.JPG";